export default {
    url: '/scale',
    template: '<user-skill-list-scale/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/skill/list/scale/index.js